const TopicExplore = function () {
  jQuery(document).ready(function ($) {

    if(jQuery('.masonry_style').length > 0) {
      var WW = jQuery(window).width();
      if (WW > 450) {
        const container = document.querySelector('.masonry_style');
        const itemSelectorClass = container.getAttribute('data-item');
        console.log(itemSelectorClass);
        const msnry = new Masonry(container, {
          itemSelector: '.thumbnail.' + itemSelectorClass,
          columnWidth: '.thumbnail.' + itemSelectorClass,
          percentPosition: true
        });
        msnry.layout();
      }
    }
  });

};

module.exports = TopicExplore;
